import React from 'react';
import { FDBox } from '@facet-wealth/design';
import { BodyTextMedium } from 'Packages/FacetDesign/Components';

export const FrequentlyAskedQuestionsSubtitle = ({ value }) => {
  return (
    <FDBox paddingX={2}>
      <BodyTextMedium value={value} />
    </FDBox>
  );
};
